import { LoaderFunction, useLoaderData, useNavigate } from "react-router-dom";
import { AviTracerApi } from "../../../avitracerApi";
import EntityDetailsPage from "../../../components/EntityDetails/EntityDetailsPage";
import { getRouteDisplayInfo, Route } from "../../../models/route";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { archiveRouteWithId, editRoute, getRoutes } from "../../../store/routesSlice";
import { useEffect } from "react";
import { fetchSwitchingTeamIfNeeded } from "../../../utils/fetchSwitchingTeam";

export const routeLoader: LoaderFunction = async (params) => {
  return fetchSwitchingTeamIfNeeded((orgId) => AviTracerApi.getRouteWithId(params.params["routeId"]!, orgId));
};


function RouteDetailsPage() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate();

  const loadedRoute = useLoaderData() as Route;
  const { status } = useAppSelector((state) => state.routes);

  useEffect(() => {
    if (status === "idle") {
      dispatch(getRoutes());
    }
  }, [dispatch, status]);

  const goBack = () => {
    navigate("/routes");
  };

  const handleSaveRoute = async (newRoute: Route) => {
    return await dispatch(editRoute(newRoute)).unwrap()
  };

  const handleArchiveRoute = async (route: Route) => {
    if (route.id) {
      return await dispatch(archiveRouteWithId(route.id)).unwrap();
    }
  };

  return (
    <EntityDetailsPage
      entity={loadedRoute}
      handleClose={goBack}
      displayInfo={getRouteDisplayInfo()}
      dispatchSaveEntity={handleSaveRoute}
      dispatchDeleteEntity={handleArchiveRoute}
    />
  );
}

export default RouteDetailsPage